function MenuAula2() {
  

    return (
      <>
        <nav>
            <ul>
              <li><a href="#O-que-é-LESS?">O que é LESS?</a></li>
              <li><a href="#Less-na-pratica">Less na prática</a></li>
              <li><a href="#Less-variáveis">Less variáveis</a></li>
              <li><a href="#Less-Hierarquia">Less Hierarquia</a></li>
              <li><a href="#Less-Função">Less Função</a></li>
              <li><a href="#Less-Função-na-prática">Less Função na prática</a></li>
              <li><a href="#Less-Mixins">Less-Mixins</a></li>
              <li><a href="#LESS-Mixins-Colocando-em-prática">LESS Mixins, Colocando em prática</a></li>
              <li><a href="#Less-Condicionais-IFs">Less Condicionais IFs</a></li>
              <li><a href="#LESS-Math-Operadores-Matemáticos">LESS Math Operadores Matemáticos</a></li>
              <li><a href="#Erros-como-evitar-eles">Erros, como evitar eles</a></li>
              <li><a href="#Criando-projeto-que-usa-Less-parte-1">Criando projeto que usa Less, parte 1</a></li>
              <li><a href="#Criando-projeto-que-usa-Less-parte-2">Criando projeto que usa Less, parte 2</a></li>
              <li><a href="#Exercício-1">Exercício 1</a></li>
            </ul>
          </nav>
      </>
    );
  }
  
  export default MenuAula2;